export default __webpack_public_path__ + "static/media/en-logo.e9b31186.png";